import { defineComponent as _defineComponent } from 'vue'
import BoolIcon from '@/components/BoolIcon.vue';
    import THGTagChip from '@/components/thg/THGTagChip.vue';
    import { useTHGUsersStore } from '@/storenew/thg/users';
    import { storeToRefs } from 'pinia';
    import { THGUserTableColumnVisibilityLabels } from '@/interfaces/thg/THGUserTableColumnVisibility';
    import { THGUserTableColumn } from '@/enums/thg/THGUserTableColumn';
    import { THGUserPaginatedResponse } from '@/interfaces/thg/THGUserPaginatedResponse';
    import { getPromotionStatusText, getUserTypeText } from '@/utils/thg';
    import { THGUser } from '@/interfaces/thg/THGUser';
    import { confirm } from '@/utils/dialogs';
    import { deleteTHGUser, saveTHGUser } from '@/api/thg/users';
    import emitter from '@/utils/mitt';
    import { useRoute, useRouter } from 'vue-router/composables';
    import { SortOrder } from '@/enums/misc';
    import { useTHGGlobalStore } from '@/storenew/thg/global';
    import { Country } from '@/enums/Country';

    interface Props {
        data?: THGUserPaginatedResponse;
        isPaginated: boolean;
        pageSize: number;
        currentPage?: number;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'GenericTHGUserTable',
  props: {
    data: null,
    isPaginated: { type: Boolean, default: false },
    pageSize: { default: 20 },
    currentPage: { default: 1 }
  },
  emits: ["onPageChange", "dataReloading"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'onPageChange', pageNum: number): void;
        (e: 'dataReloading'): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { data?: THGUserPaginatedResponse, isPaginated: boolean, pageSize: number, currentPage: number };

    

    const router = useRouter();
    const route = useRoute();

    

    const store = useTHGUsersStore();
    const { currentCountry } = useTHGGlobalStore();
    const { columnVisibility } = storeToRefs(store);

    const columnVisibilityLabels: THGUserTableColumnVisibilityLabels = {
        [THGUserTableColumn.VAT_NUMBER]: 'UID',
        [THGUserTableColumn.COMPANY_NAME]: 'Firma',
        [THGUserTableColumn.FIRST_NAME]: 'Vorname',
        [THGUserTableColumn.LAST_NAME]: 'Nachname',
        [THGUserTableColumn.STREET]: 'Straße',
        [THGUserTableColumn.ZIP_CODE]: 'PLZ',
        [THGUserTableColumn.CITY]: 'Ort',
        [THGUserTableColumn.PAYEE]: 'Zahlungsempfänger',
        [THGUserTableColumn.IBAN]: 'IBAN',
        [THGUserTableColumn.REGISTRATION_LIMIT]: 'Registrierungslimit',
        [THGUserTableColumn.PROMO_NUMBER]: 'Anzahl Weiterempfehlungen',
        [THGUserTableColumn.PROMO_STATUS]: 'Status Weiterempfehlungen',
        [THGUserTableColumn.ADAC_MEMBER_NUMBER]: 'ADAC-Mitgliedsnummer',
        [THGUserTableColumn.REFERRAL_CODE]: 'Empfohlen von (Code)',
        [THGUserTableColumn.TAGS]: 'Tags',
    };

    const onPageChange = (pageNum: number) => emit('onPageChange', pageNum);

    async function onSortChange(field: string, order: SortOrder) {
        const { sortData } = storeToRefs(useTHGUsersStore());
        sortData.value = { field: field, order: order };

        emit('dataReloading');
    }

    async function reactivateUser(userObj: THGUser) {
        const question = `Solle der THG-Benutzer ${userObj.email} wirklich reaktiviert werden?`;
        const { result, dialog } = await confirm(
            'Benutzer reaktivieren',
            question,
            'Reaktivieren',
            'is-warning',
        );

        if (result) {
            emitter.emit('showLoader');

            await saveTHGUser(userObj.id, {
                is_active: true,
            });

            // close dialog and re-fetch data
            dialog.close();

            // emit the dataReloading event and close the loader
            emit('dataReloading');
            emitter.emit('hideLoader');
        }
    }

    async function deactivateUser(userObj: THGUser) {
        const question = `Soll der THG-Benutzer ${userObj.email} wirklich deaktiviert werden?`;
        const { result, dialog } = await confirm(
            'Benutzer deaktivieren',
            question,
            'Deaktivieren',
            'is-warning',
        );

        if (result) {
            emitter.emit('showLoader');

            await saveTHGUser(userObj.id, {
                is_active: false,
            });

            // close dialog and re-fetch data
            dialog.close();

            // emit the dataReloading event and close the loader
            emit('dataReloading');
            emitter.emit('hideLoader');
        }
    }

    function editUser(row: THGUser) {
        if (!route.name) {
            throw new Error('Route name is undefined');
        }

        router.push({
            name: 'thguser',
            params: { userId: row.id, prevRouteName: route.name },
        });
    }

    function showCars(row: THGUser) {
        if (!route.name) {
            throw new Error('Route name is undefined');
        }

        router.push({
            name: 'thgusercarslist',
            params: {
                userId: row.id,
                user: row as never as string,
                prevRouteName: route.name,
            },
        });
    }

    async function deleteUser(userObj: THGUser) {
        const question = `Sollen der THG-Benutzer ${userObj.email} und all seine Fahrzeuge(!) wirklich gelöscht werden?`;
        const { result, dialog } = await confirm(
            'Benutzer löschen',
            question,
            'Löschen',
            'is-danger',
        );

        if (result) {
            // start loading
            emitter.emit('showLoader');

            await deleteTHGUser(userObj.id);

            // close dialog and re-fetch data
            dialog.close();

            // emit the dataReloading event and close the loader
            emit('dataReloading');
            emitter.emit('hideLoader');
        }
    }

    function formatDonationRatio(ratio: number | null): string {
        if (ratio === null) {
            return '';
        }

        return `${Number(ratio * 100).toLocaleString()}%`;
    }

return { __sfc: true,props, router, route, emit, store, currentCountry, columnVisibility, columnVisibilityLabels, onPageChange, onSortChange, reactivateUser, deactivateUser, editUser, showCars, deleteUser, formatDonationRatio, BoolIcon, THGTagChip, getPromotionStatusText, getUserTypeText, Country }
}

})